// What the launcher, the gate card and the run actions say to the investigation's agent. Each
// writes through RPC only, and the agent acts on chat turns, so without one of these the run sits idle.

export const workflowStartedMessage = (title: string, runId: string): string =>
  `Started workflow '${title}' (run ${runId}). Walk it from its current step.`;

export const gateResolvedMessage = (
  stepLabel: string,
  runId: string,
  approved: boolean,
  note?: string,
): string => {
  const head = approved
    ? `I approved the gate on '${stepLabel}' in run ${runId}. Continue the workflow.`
    : `I rejected the gate on '${stepLabel}' in run ${runId}, so the run is stopped.`;
  return note ? `${head} Note: ${note}` : head;
};

export const stepRetriedMessage = (stepLabel: string, runId: string): string =>
  `I retried step '${stepLabel}' in run ${runId}. Continue the workflow.`;

export const runAbandonedMessage = (runId: string, reason: string): string =>
  `I abandoned run ${runId}: ${reason}`;

export const branchTakenMessage = (
  stepLabel: string,
  runId: string,
  condition: string,
): string =>
  `I answered "${stepLabel}" on workflow run ${runId}: ${condition}. Carry on from there.`;
